import React from "react";
import ServiceOne from "../../assets/nri-loan-img.png";
import { useNavigate } from "react-router-dom";
import { FaImage, FaIdCard, FaFileAlt, FaHome, FaUsers, FaMoneyBillWave, FaGlobe  } from "react-icons/fa";
import { MdOutlineDescription } from "react-icons/md";


const NriLoanOffer = () => {
  const navigate = useNavigate();
  const plans = [
    {
      loanType: "nri",
      title: "NRI Loan",
    },
  ];

  const handleApplyClick = (loanType) => {
    navigate("/otp-verification/nri-loan", { state: { loanType } });
  };

  return (
    <div className="loan-offer-wrapper">
      <div className="ourservice-logo">
        <div className="ourservice-text">
          <h2 className="ourservice-offer-subtitle">NRI Loan</h2>
        </div>
        <p className="offer-title-ourservice offer-submain-title">
          {" "}
          Get NRI Personal Loan From{" "}
          <span className="highlight-color">₹3 Lakh to ₹15 Lakhs*</span>
        </p>
      </div>

      <div className="loan-highlights">
        <div className="salary-rate-pair">
          <div className="salary-rate-list">
            <div className="salary-rate-box">
              <p>Right Lender Approvals in</p>
              <span><h3>24 hrs</h3></span>
            </div>
            <div className="salary-rate-box">
              <p>Interest Rate Starts @</p>
              <h3>12%*</h3>
            </div>
            <div className="salary-rate-box">
              <p>Tenure up to</p>
              <h3>36*</h3>
              <p>Months</p>
            </div>
            <div className="salary-rate-box">
              <p>EMI </p>
              <h3>₹3321*</h3>
              <p>P/M</p>
            </div>
          </div>
        </div>
        <p className="offer-subtitle highlight-rate">No Collateral Required</p>
      </div>

      <div className="rate-cards-container">
        <h4 className="offer-title-ourservice">Who Can Apply</h4>
        <div className="rate-cards-list">
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>CIBIL 720 & Above
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Age 23 to 56
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Net Salary Min ₹1Lakh
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Active NRE/NRO Account
              in India
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Co-Applicant Mandatory
            </p>
          </div>
        </div>
      </div>

      <div className="rate-cards-container">
        <h4 className="offer-title-ourservice">Documents</h4>
        <div className="rate-cards-list">
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Selfie (or ) Photo
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Pan
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Aadhaar or E-Aadhaar
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Last 3 Month Pay Slip
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Last 6 Month Salary
              Account Statement & Remittance Account
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Passport & Visa
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Co Applicant Documents
            </p>
          </div>
        </div>
      </div>
      <div className="offer-subtitle">
        <p>
          <span className="highlight-rate">Service Available All Over Tamil Nadu</span><br />
          (Right Lender Serviceable PIN code)
        </p>
      </div>

      <div className="apply-now-button">
        {plans.map((plan, index) => (
          <button
            className="apply-loan-button"
            key={index}
            onClick={() => handleApplyClick(plan.loanType)}
          >
            Proceed
          </button>
        ))}
      </div>
    </div>
  );
};

export default NriLoanOffer;
